/** Per-route SEO for public marketing/auth pages (used with react-helmet-async + prerender). */

export const SITE_NAME = "JD Integrations";
export const DEFAULT_SITE_URL = "https://jdintegrations.net";
export const DEFAULT_OG_IMAGE = `${DEFAULT_SITE_URL}/og-image.png`;

export function siteBaseUrl() {
  const raw = process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL;
  return String(raw).replace(/\/$/, "");
}

/**
 * @type {Record<string, { title: string, description: string, noindex?: boolean, waitFor?: string }>}
 */
export const PUBLIC_PAGE_SEO = {
  "/": {
    title: "JD Integrations — Modular ERP with Built-In Integrations",
    description:
      "Connect accounting, HR, payroll, inventory, sales, and procurement on one modular ERP platform. Subscribe per module and scale with integrations that keep operations in sync.",
    waitFor: "Run your whole business",
  },
  "/about": {
    title: "About — JD Integrations",
    description:
      "Learn how JD Integrations builds connected ERP software for modern teams—modular subscriptions, cross-module integrations, and practical automation.",
    waitFor: "About JD Integrations",
  },
  "/features": {
    title: "Features — JD Integrations",
    description:
      "Explore modular ERP features for finance, people operations, supply chain, and revenue—with integrations that link journals, inventory, purchase orders, and payroll.",
    waitFor: "Why teams choose us",
  },
  "/pricing": {
    title: "Pricing — JD Integrations",
    description:
      "Transparent per-module subscription pricing for JD Integrations ERP. Pay only for the modules your team needs and add integrations as you grow.",
    waitFor: "Module pricing",
  },
  "/integrations": {
    title: "Integrations — JD Integrations",
    description:
      "See how JD Integrations modules connect in real time—from procurement and inventory to general ledger entries and payroll runs.",
    waitFor: "How modules connect",
  },
  "/contact": {
    title: "Contact — JD Integrations",
    description:
      "Contact JD Integrations for demos, integration questions, and support for your modular ERP rollout.",
    waitFor: "Get in touch",
  },
  "/blog": {
    title: "Blog — JD Integrations",
    description:
      "Insights on ERP, integrations, and operations from the JD Integrations team.",
    waitFor: "Blog",
  },
  "/login": {
    title: "Sign in — JD Integrations",
    description: "Sign in to your JD Integrations organization workspace.",
    noindex: true,
    waitFor: "Sign in",
  },
  "/signup": {
    title: "Create account — JD Integrations",
    description:
      "Create a JD Integrations organization and start your modular ERP trial.",
    noindex: true,
    waitFor: "Start a trial",
  },
};

export const PRERENDER_ROUTES = Object.keys(PUBLIC_PAGE_SEO);
